const route = [
    {
        path: '/activity/2024qz/index', //2024下期中检测
        component: function (resolve) {
            require(['VIEWS/activity/2024qz/index.vue'], resolve);
        }
    },
]
export default route;
